import React, { useMemo } from 'react';
import { useEventLeads } from '../../../../../../data/hooks/leads/useEventLeads';
import ParticipantsList from '../../../../../elements/ParticipantsList/ParticipantsList';
import { useGroupedLeads } from '../useGroupedLeads';
import EmptyLeadsList from './EmptyLeadsList';
import { routePrefixFn } from './routePrefixFn';

function MyLeads(props) {
    const { className, eventId } = props,
        leads = useEventLeads(eventId),
        participants = useMemo(() => leads?.map((lead) => lead.participant), [leads]),
        groupedLeads = useGroupedLeads(leads);

    if (!participants.length) return <EmptyLeadsList />;

    return <ParticipantsList className={className} eventId={eventId} list={groupedLeads} savePosition={'leads-mine-' + eventId} routePrefixFn={routePrefixFn} />;
}

export default MyLeads;
